<template>
    <div class="accordion-item">
        <div :class="`acc-title-con ${!opened ? '' : 'opened'}`" @click="opened = !opened">
            {{ title | normalize }}
            <span class="sub-title">
                {{ subTitle | normalize }}
            </span>
        </div>
        <div class="acc-content-con" v-if="opened && !useSlotContent" v-html="content"></div>
        <div :class="`acc-content-con ${customContainer ? 'custom-con' : ''}`" v-if="opened && useSlotContent">
            <slot name="acc-content"></slot>
        </div>
    </div>
</template>

<script>
    import AccordionItem from '@views/common/AccordionItem/accordion_item'
    
    export default {
        mixins: [AccordionItem]
    }
</script>

<style lang="scss" src="./accordion_item.scss"></style>